import { apiClient } from "./client";

export async function searchOrganisations(q = "", limit = 20) {
  const res = await apiClient.get("/organisations/search", {
    params: { q, limit },
  });
  return res.data;
}

export async function fetchOrganisationDashboard() {
  const res = await apiClient.get("/organisation/dashboard");
  return res.data;
}

/** Update organisation profile: logoUrl, description, websiteUrl */
export async function updateOrganisationProfile(dto) {
  const res = await apiClient.patch("/organisation/profile", dto);
  return res.data;
}

/** Live check for the registration form. Public -- no auth required. */
export async function checkOrganisationAvailability(registrationNumber) {
  const res = await apiClient.get("/organisations/check-availability", {
    params: { registrationNumber },
  });
  return res.data;
}

/** Re-upload after rejection -- flips status back to PENDING_REVIEW. */
export async function resubmitOrganisationDocument(s3Key) {
  const res = await apiClient.post(
    "/organisation/resubmit-registration-document",
    { s3Key },
  );
  return res.data;
}

// ---------- Multi-branch organisation ----------
//
// Branches always hang off a PARENT organisation. Every call below either
// carries the parent organisation id in the path, or is scoped to the caller's
// own organisation by the server from their token. The frontend never gets to
// decide which organisation a branch belongs to.

/** Officer-side: my organisation's branches, INCLUDING inactive ones (admin view). */
export async function fetchMyBranches() {
  const res = await apiClient.get("/organisation/branches");
  return res.data;
}

/**
 * Admin view for an explicit parent organisation -- inactive branches included
 * so they can be seen and reactivated. Caller must be an officer of that org.
 */
export async function fetchBranchesForAdmin(organisationId) {
  const res = await apiClient.get(`/organisations/${organisationId}/branches`, {
    params: { includeInactive: "true" },
  });
  return res.data;
}

/** Officer-side (admin): register a branch under a parent organisation. */
export async function createBranch(organisationId, dto) {
  const res = await apiClient.post(
    `/organisations/${organisationId}/branches`,
    dto,
  );
  return res.data;
}

/** Officer-side (admin): edit a branch's details. */
export async function updateBranch(organisationId, branchId, dto) {
  const res = await apiClient.patch(
    `/organisations/${organisationId}/branches/${branchId}`,
    dto,
  );
  return res.data;
}

/**
 * Officer-side (admin): activate / deactivate. Soft -- the branch row and every
 * historical record pointing at it survive.
 */
export async function setBranchActive(organisationId, branchId, isActive) {
  const res = await apiClient.patch(
    `/organisations/${organisationId}/branches/${branchId}/status`,
    { isActive },
  );
  return res.data;
}

/**
 * Officer-side (admin): permanently delete a branch.
 */
export async function deleteBranch(organisationId, branchId) {
  const res = await apiClient.delete(
    `/organisations/${organisationId}/branches/${branchId}`,
  );
  return res.data;
}

/** Read one branch, scoped to its parent organisation. */
export async function fetchBranch(organisationId, branchId) {
  const res = await apiClient.get(
    `/organisations/${organisationId}/branches/${branchId}`,
  );
  return res.data;
}

/**
 * SELECTION list: active branches of an approved organisation, for authenticated
 * users (e.g. a professional picking the office on a work credential).
 * Inactive branches are never returned by the server.
 */
export async function fetchOrganisationBranches(organisationId) {
  const res = await apiClient.get(`/organisations/${organisationId}/branches`);
  return res.data;
}
